"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var BillingApiOperationResponseDto_1;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiOperationResponseDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const key_value_1 = require("../../../../shared/types/key-value");
const swagger_1 = require("../../../../swagger-fake");
const types_1 = require("../../../billing-api-transaction/types");
let BillingApiOperationResponseDto = BillingApiOperationResponseDto_1 = class BillingApiOperationResponseDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id операции",
  format: "uuid",
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiOperationResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Все проводки в операции (если запрошено явно; joined-свойство)",
  type: () => types_1.BillingApiTransactionResponseDto,
  isArray: true,
  nullable: true,
  example: [{
    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    "operationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    "accountId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    "rate": "string",
    "amount": "string",
    "currencyCode": "USD",
    "type": "PURCHASE",
    "ledgerType": "DEBIT",
    "meta": {
      "chargeId": "f4c92982-1437-4c66-80a2-2bfd164584ed"
    },
    "createdAt": "2023-10-12T17:56:53.605Z"
  }]
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsObject)(), (0, class_transformer_1.Type)(() => types_1.BillingApiTransactionResponseDto), __metadata("design:type", Object)], BillingApiOperationResponseDto.prototype, "transactions", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Meta-данные",
  type: () => key_value_1.Metadata,
  example: {
    chargeId: "f4c92982-1437-4c66-80a2-2bfd164584ed"
  }
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsObject)(), __metadata("design:type", Object)], BillingApiOperationResponseDto.prototype, "meta", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата создания",
  format: "date-time"
}), (0, class_transformer_1.Expose)(), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), __metadata("design:type", Date)], BillingApiOperationResponseDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дочерняя операция (при использовании опции запроса joinChild)",
  type: () => BillingApiOperationResponseDto_1,
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsObject)(), __metadata("design:type", Object)], BillingApiOperationResponseDto.prototype, "child", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Все связанные операции (при использовании опции запроса joinRelated)",
  type: () => BillingApiOperationResponseDto_1,
  isArray: true,
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsObject)(), __metadata("design:type", Object)], BillingApiOperationResponseDto.prototype, "related", void 0);
BillingApiOperationResponseDto = BillingApiOperationResponseDto_1 = __decorate([(0, class_transformer_1.Exclude)()], BillingApiOperationResponseDto);
exports.BillingApiOperationResponseDto = BillingApiOperationResponseDto;
